import PropTypes from 'prop-types';
import React, { memo } from 'react';
import {
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import css from 'styled-jsx/css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

export default memo(AssetV2MaintenanceMobileFiltersModal);

const { className, styles } = css.resolve`
  .modal-dialog {
    margin-top: 75px;
  }
`;

function AssetV2MaintenanceMobileFiltersModal(props) {
  return (
    <Modal
      backdropClassName="bg-transparent"
      className={className}
      isOpen={props.isOpen}
      scrollable
      toggle={props.toggleModal}
    >
      <ModalHeader className="border-bottom-0" toggle={props.toggleModal}>
        <p className="mb-0 font-weight-normal nine-tenth-text">Filters</p>
      </ModalHeader>
      <ModalBody>
        <InputGroup className="mt-2" size="sm">
          <Input
            className="form-control text-text-light-gray border-right-0 nine-tenth-text"
            disabled={props.dataLoading}
            name="reminder_name"
            onChange={props.handleStatePropUpdate}
            placeholder="Filter by Reminder Name"
            type="text"
            value={props.reminder_name}
          />
          <InputGroupAddon addonType="append">
            <InputGroupText className="input-group-text border-left-0 bg-white">
              <FontAwesomeIcon
                className="text-text-light-gray"
                icon={faSearch}
                size="xs"
              />
            </InputGroupText>
          </InputGroupAddon>
        </InputGroup>
      </ModalBody>
      <ModalFooter className="align-items-center justify-content-center border-top-0">
        <button
          className="btn btn-block btn-outline-third-gray text-text-gray bg-white py-0"
          onClick={props.handleClearFiltersClick}
        >
          Clear Filters
        </button>
      </ModalFooter>
      {styles}
      <style jsx>{`
        .btn:focus {
          outline: none !important;
        }
      `}</style>
    </Modal>
  );
}

AssetV2MaintenanceMobileFiltersModal.propTypes = {
  handleClearFiltersClick: PropTypes.func,
  dataLoading: PropTypes.func,
  handleStatePropUpdate: PropTypes.func,
  isOpen: PropTypes.bool,
  reminder_name: PropTypes.string,
  toggleModal: PropTypes.func,
};
